var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDuplicateIcon = function SvgDuplicateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13997_38872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3133 8.27896H8.96923C8.58927 8.27896 8.28125 8.58698 8.28125 8.96694V16.311C8.28125 16.6909 8.58927 16.999 8.96923 16.999H16.3133C16.6932 16.999 17.0013 16.6909 17.0013 16.311V8.96694C17.0013 8.58698 16.6932 8.27896 16.3133 8.27896Z",
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49143 11.72H4.24571C3.55772 11.72 3 11.1623 3 10.4743V4.24571C3 3.55772 3.55772 3 4.24571 3H10.4743C11.1623 3 11.72 3.55773 11.72 4.24571V5.49143",
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13997_38872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(-7 -7)"
  })))));
};
export { SvgDuplicateIcon as ReactComponent };
export default __webpack_public_path__ + "duplicate-icon.svg";